import { useQuery } from '@tanstack/react-query';

import { validateShareLink } from '@/api/v4/account.api';
import { QueryKey } from '@/config/query-client';

export const useValidateShareLink = (linkId: string) => {
  return useQuery({
    gcTime: 0,
    enabled: !!linkId,
    queryFn: () => validateShareLink({ linkId }),
    queryKey: [QueryKey.ShareLinkValidation, linkId],
    refetchOnMount: 'always',
    retry: false,
    staleTime: 0,
  });
};
